import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context as ReactContext, useContext, useEffect, useState } from 'react';

import { IMachineLearningExperimentRunResult } from '../../Common/MachineLearningModels/MachineLearningExperimentRunResult';

export function useMachineLearningExperimentResults(
  experimentId: string,
  selectedDate: Date | null
): [IMachineLearningExperimentRunResult[], () => void] {
  const [results, setResults] = useState<IMachineLearningExperimentRunResult[]>([]); // [IExperiment
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  function loadResults() {
    if (selectedDate == null)  return

    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const day = String(selectedDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    httpClient
      .request<IMachineLearningExperimentRunResult[]>({
        url: `${__API_BASE_URL__}/machine-learning/experiments/${experimentId}/results/${formattedDate}`,
        resource: __CLIENT_ID__,
      })
      .then(({ data }) => {
        setResults(data);
      });
  }

  useEffect(loadResults, [experimentId,selectedDate]);

  return [results, loadResults];
}
